
/*
 * Copyright (c) Aista Ltd, and Thomas Hansen - For license inquiries you can contact thomas@ainiro.io.
 */

import { Component } from '@angular/core';

/**
 * Privacy dialog showing user Aista's privacy declaration.
 */
@Component({
  selector: 'app-privacy-modal',
  templateUrl: './privacy-modal.component.html',
})
export class PrivacyModalComponent {
}
